import React from "react";
import {
    getUnits,
    toggleUnitActive,
    bulkDeleteUnits,
} from "../../../../api/products";
import SaveUnit from './createEditModal'
import TableData from "../../../../_components/TableData";
import LoadingContainer from "../../../../_components/LoadingContainer";
import Button from "../../../../_components/Button";
import Dropdown, { DropDownDivider, DropDownItem } from "../../../../_components/Dropdown";
import CheckBox from "../../../../_components/Checkbox";
import Modal from "../../../../_components/Modal";
import CustomSelect from "../../../../design-system/atoms/Select";

export default (props) => {
    const [units, setUnits] = React.useState([])
    const [allUnits, setAllUnits] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [showModal, setShowModal] = React.useState(false)
    const [editData, setEditData] = React.useState(false)
    const [selectedIds, setSelectedIds] = React.useState([])
    const [showConfirmModal, setShowConfirmModal] = React.useState(false)
    const [bulkAction, setBulkAction] = React.useState("")

    const [formSearchText, setFormSearchText] = React.useState("")
    const [formFilterActive, setFormFilterActive] = React.useState("true")

    function applyFilters(data, activeFilter, textFilter) {
        let filtered = data;
        
        if (activeFilter !== "all") {
            const isActive = activeFilter === "true"
            filtered = filtered.filter(u => Boolean(u.is_active) === isActive || (u.is_active === undefined && isActive)) // If undefined (global unit), it is implicitly active
        }
        
        if (textFilter.trim().length >= 2) {
            filtered = filtered.filter(u => u.name.toLowerCase().includes(textFilter.trim().toLowerCase()))
        }
        
        setUnits(filtered)
        setSelectedIds([])
    }

    function _getUnits() {
        setLoading(true)
        getUnits()
            .then(data => {
                setAllUnits(data)
                applyFilters(data, formFilterActive, formSearchText)
            })
            .finally(() => setLoading(false))
    }

    React.useEffect(() => {
        _getUnits()
    }, [])



    function handleSelectAll(itemKey, checked) {
        if (checked) {
            setSelectedIds(units.map(u => u.id))
        } else {
            setSelectedIds([])
        }
    }

    function handleSelect(id, checked) {
        if (checked) {
            setSelectedIds([...selectedIds, id])
        } else {
            setSelectedIds(selectedIds.filter(i => i !== id))
        }
    }

    function handleBulkDelete() {
        setShowConfirmModal(true)
    }

    function handleBulkAction() {
        if (!bulkAction) return;
        
        if (bulkAction === 'delete') {
            setShowConfirmModal(true)
        } else {
            setLoading(true)
            const targetState = bulkAction === 'deactivate'; // if deactivate, we pretend current is true to send DELETE
            const promises = selectedIds.map(id => toggleUnitActive(id, targetState));
            Promise.all(promises).then(() => {
                _getUnits();
            }).finally(() => setLoading(false))
        }
    }

    function confirmBulkDelete() {
        setLoading(true)
        bulkDeleteUnits(selectedIds).then(() => {
            _getUnits();
            setShowConfirmModal(false);
        }).catch(() => {
            alert("Algumas unidades podem ser globais e não podem ser desativadas.");
            _getUnits();
            setShowConfirmModal(false);
        }).finally(() => setLoading(false))
    }

    const tableData = units.map((unit, index) => ({
        ...unit,
        checkbox: <CheckBox 
                    checked={selectedIds.includes(unit.id)} 
                    itemKey={unit.id} 
                    onClick={unit.is_active !== undefined ? handleSelect : () => {}} 
                  />,
        number: index + 1,
        name: <React.Fragment>{unit.name} {unit.is_active === undefined && <span className="badge badge-info ml-2">Global</span>}</React.Fragment>,
        status: (
            <span className={`badge badge-${(unit.is_active === undefined || unit.is_active) ? 'success' : 'secondary'}`}>
                {unit.is_active === undefined ? "Ativo" : (unit.is_active ? "Ativo" : "Desativado")}
            </span>
        ),
        actions: unit.is_active !== undefined ? (
            <Dropdown>
                <DropDownItem>
                    <Button
                        as="text"
                        className="mx-1"
                        onClick={() => {
                            setEditData(unit);
                            setShowModal(true)
                        }}
                    >
                        <i className="fa fa-edit" />{" "}
                        <span>Editar</span>
                    </Button>
                </DropDownItem>
                <DropDownDivider />
                <DropDownItem>
                    <Button
                        as="text"
                        className={`${unit.is_active ? 'text-danger' : 'text-success'} mx-1`}
                        onClick={() => {
                            setLoading(true)
                            toggleUnitActive(unit.id, unit.is_active).then(() => _getUnits())
                        }}
                    >
                        <i className={`fa fa-${unit.is_active ? 'ban' : 'check'}`} />{" "}
                        <span>{unit.is_active ? "Desativar" : "Reativar"}</span>
                    </Button>
                </DropDownItem>
            </Dropdown>
        ) : (
            <span className="text-muted">Não editável</span>
        )
    }))

    const headerCheckbox = (
        <CheckBox 
            checked={selectedIds.length > 0 && selectedIds.length === units.length} 
            itemKey="all"
            onClick={handleSelectAll} 
        />
    )

    return (
        <LoadingContainer loading={loading}>
            <div className="mb-2">
                <p className="lead mb-3 pb-1 text-center">
                    Unidades Comerciais
                </p>
                <div 
                    className="d-flex flex-wrap align-items-center justify-content-between mb-4 bg-white p-3 rounded"
                    style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.05)', border: '1px solid #eaeaea' }}
                >
                    <div className="d-flex flex-wrap align-items-center" style={{ gap: '15px' }}>
                        <Button
                            style={{ 
                                height: '38px', 
                                borderRadius: '6px', 
                                fontWeight: '600', 
                                padding: '0 20px', 
                                boxShadow: '0 2px 4px rgba(0, 169, 255, 0.25)',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                            onClick={() => {
                                setEditData(false)
                                setShowModal(true)
                            }}
                            variant="primary">
                            <i className="fas fa-plus mr-2" style={{ marginRight: '8px' }}></i> Criar Unidade
                        </Button>
                        
                        {selectedIds.length > 0 && (
                            <div className="d-flex align-items-center" style={{ gap: '10px', borderLeft: '1px solid #e5e7eb', paddingLeft: '15px' }}>
                                <div style={{ width: '180px' }}>
                                    <CustomSelect 
                                        style={{ height: '38px', borderRadius: '6px' }}
                                        options={[
                                            { value: '', label: 'Ação em lote...' },
                                            { value: 'activate', label: 'Ativar' },
                                            { value: 'deactivate', label: 'Desativar' },
                                            { value: 'delete', label: 'Excluir' }
                                        ]}
                                        value={bulkAction}
                                        onChange={e => setBulkAction(e.target.value)}
                                    />
                                </div>
                                <button 
                                    className="btn"
                                    style={{ 
                                        height: '38px', 
                                        borderRadius: '6px', 
                                        fontWeight: '500', 
                                        border: '1px solid #d1d5db', 
                                        background: '#f9fafb', 
                                        color: '#374151',
                                        display: 'flex',
                                        alignItems: 'center',
                                        transition: 'all 0.2s'
                                    }} 
                                    onClick={handleBulkAction} 
                                    disabled={!bulkAction}
                                    onMouseOver={(e) => !(!bulkAction) && (e.currentTarget.style.background = '#f3f4f6')}
                                    onMouseOut={(e) => !(!bulkAction) && (e.currentTarget.style.background = '#f9fafb')}
                                >
                                    Aplicar ({selectedIds.length})
                                </button>
                            </div>
                        )}
                    </div>
                    
                    <div className="d-flex flex-wrap align-items-center mt-3 mt-md-0" style={{ gap: '15px' }}>
                        <div style={{ width: '250px' }} className="position-relative">
                            <i className="fas fa-search position-absolute text-muted" style={{ left: '12px', top: '50%', transform: 'translateY(-50%)' }}></i>
                            <input 
                                type="text" 
                                className="form-control" 
                                style={{ height: '38px', borderRadius: '6px', paddingLeft: '35px' }}
                                placeholder="Pesquisar unidade..." 
                                value={formSearchText}
                                onChange={e => {
                                    setFormSearchText(e.target.value)
                                    applyFilters(allUnits, formFilterActive, e.target.value)
                                }}
                            />
                        </div>
                        <div style={{ width: '180px' }}>
                            <CustomSelect 
                                style={{ height: '38px', borderRadius: '6px' }}
                                options={[
                                    { value: 'all', label: 'Todos os Status' },
                                    { value: 'true', label: 'Ativos' },
                                    { value: 'false', label: 'Desativados' }
                                ]}
                                value={formFilterActive}
                                onChange={e => {
                                    setFormFilterActive(e.target.value)
                                    applyFilters(allUnits, e.target.value, formSearchText)
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            
            <TableData
                data={tableData}
                tHead={[headerCheckbox, "#", "Nome", "Status", "Ações"]}
                tBodyKeys={["checkbox", "number", "name", "status", "actions"]}
            />

            <SaveUnit
                show={showModal}
                edit={editData}
                existingItems={allUnits}
                onHide={() => {
                    _getUnits()
                    setEditData(false)
                    setShowModal(false)
                }}
            />

            <Modal
                title="Confirmar Desativação"
                show={showConfirmModal}
                onHide={() => setShowConfirmModal(false)}
                size="md"
            >
                <div className="text-center p-3">
                    <p>Deseja realmente desativar as unidades selecionadas?</p>
                    <div className="d-flex flex-column align-items-center mt-4">
                        <Button variant="danger" className="mb-3 px-5" loading={loading} onClick={confirmBulkDelete}>
                            Confirmar
                        </Button>
                        <Button as="text" className="text-danger" onClick={() => setShowConfirmModal(false)}>
                            Cancelar
                        </Button>
                    </div>
                </div>
            </Modal>
        </LoadingContainer>
    )
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Products/Units/list.jsx